import { render, staticRenderFns } from "./EventsTable.vue?vue&type=template&id=50a2d97b&"
import script from "./EventsTable.vue?vue&type=script&lang=ts&"
export * from "./EventsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports